import React from "react";
import { useHistory } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { Button } from "react-bootstrap";

import { Manifest, Client } from "services/action";

import {
  Page,
  MapBoxManifest,
  LoadingScreen,
  DeniedScreen,
} from "ui/components";

import { formatDate, waFormat } from "utilities/common";

import Legs from "./component/legs";
import CompleteScreen from "./component/complete";
// import ManifestNoLegs from "./component/no.legs";

const DetailManifest = ({ match }) => {
  const Dispatch = useDispatch();
  const History = useHistory();
  const StateLoading = useSelector(
    (state) => state?.Activity?.services["Manifest.Show"]
  );

  const [data, setData] = React.useState(null);
  const [client, setClient] = React.useState(null);
  const [denied, setDenied] = React.useState(false);

  const $onLoad = async (id) => {
    const req = await Dispatch(Manifest.$show(id));

    if (req?.message === "success") {
      if (req?.data !== null) {
        setData(req?.data);
        $showClient(req?.data?.client_id);
      } else {
        setDenied(true);
      }
    }
  };

  const $showClient = async (id) => {
    const res = await Dispatch(Client.$show(id));
    if (res?.message === "success") {
      setClient(res?.data);
    }
  };

  React.useEffect(() => {
    $onLoad(match?.params?.id);
  }, [match?.params?.id]);

  if (StateLoading) {
    return <LoadingScreen />;
  }

  if (denied) {
    return <DeniedScreen />;
  }

  if (data?.status === "completed") {
    return <CompleteScreen data={data} />;
  }

  return (
    <Page
      title={`Detail Manifest`}
      backTo={() => History.goBack()}
      action={
        <div>
          {data?.status === "published" ? (
            <Button
              type="button"
              variant="success"
              className="pe-4 ps-4 rounded w-100 fs-7"
              onClick={() =>
                History.push({
                  pathname: "/start",
                  state: {
                    manifest_id: data?.id,
                    code: data?.code,
                    status: data?.status,
                  },
                })
              }
            >
              Mulai Manifest
            </Button>
          ) : null}

          {/* {data?.status === "started" &&
          ((data?.legs &&
            data?.legs_count?.total === data?.legs_count?.completed) ||
            !data?.legs) ? (
            <Button
              type="button"
              variant="primary"
              className="pe-4 ps-4 rounded w-100 fs-7"
              onClick={() =>
                History.push({
                  pathname: "/finish",
                  state: {
                    manifest_id: data?.id,
                  },
                })
              }
            >
              Selesaikan Manifest
            </Button>
          ) : null} */}

          <Button
            type="button"
            variant="secondary"
            className="pe-4 ps-4 rounded w-100 text-capitalize fs-7 mt-2"
            onClick={() =>
              window.open(
                `https://wa.me/${waFormat(
                  client?.phone
                )}?text=Pengiriman%20dengan%20kode%20${
                  data?.code
                }%20mengalami%20kendala`,
                "_blank"
              )
            }
          >
            Laporkan Kendala
          </Button>
        </div>
      }
    >
      <MapBoxManifest legs={data?.legs} />

      <div className="position-relative pb-3">
        <div className="px-3 py-2">
          <div className="d-flex flex-row align-items-end justify-content-between">
            <div className="fw-bold">
              Proses ({data?.legs_count?.completed}/{data?.legs_count?.total})
            </div>
            <div className="page-pretitle">
              {formatDate(data?.schedule_at, "DD/MM/YYYY")}
            </div>
          </div>
        </div>

        <div className="mb-5">
          <Legs
            data={data?.legs}
            manifestID={data?.id}
            status={data?.status}
            trucking={data?.is_trucking}
            type={data?.type}
          />
        </div>
      </div>

      {/* {data?.legs ? (
        <>
          <MapBoxManifest legs={data?.legs} />

          <div className="position-relative pb-3">
            <div className="px-3 py-2">
              <div className="d-flex flex-row align-items-end justify-content-between">
                <div className="fw-bold">
                  Proses ({data?.legs_count?.completed}/
                  {data?.legs_count?.total})
                </div>
                <div className="page-pretitle">
                  {formatDate(data?.schedule_at, "DD/MM/YYYY")}
                </div>
              </div>
            </div>

            <div className="mb-5">
              <Legs
                data={data?.legs}
                manifestID={data?.id}
                status={data?.status}
              />
            </div>
          </div>
        </>
      ) : (
        <div className="py-2">
          <ManifestNoLegs data={data} />
        </div>
      )} */}
    </Page>
  );
};

export default DetailManifest;
